import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { APIURL } from '../../../config';
import {
    Box,
    Typography,
    List,
    ListItem,
    ListItemText,
    Paper,
    Divider,
    Chip,
    Stack,
    CircularProgress
} from '@mui/material';
import Grid from '@mui/material/Grid';

const ViewEmployeeRelationship = (props) => {
    const [relationships, setRelationships] = useState([]);
    const [loading, setLoading] = useState(true);
    const [groupedRelationships, setGroupedRelationships] = useState({});

    useEffect(() => {
        const fetchRelationships = async () => {
            try {
                setLoading(true);
                const response = await axios.get(`${APIURL}/employees/hrstructure`, {
                    params: { comp_id: props.comp_id, emp_id: props.user_id }
                });
                setRelationships(response.data || []);
            } catch (error) {
                console.error('Error fetching employee relationships:', error);
                setRelationships([]);
            } finally {
                setLoading(false);
            }
        };

        if (props.user_id && props.comp_id) {
            fetchRelationships();
        }
    }, [props.user_id, props.comp_id]);

    const getEmployeeName = (empId) => {
        const employee = props.empList?.find(emp => emp.emp_id === empId);
        return employee ? `${employee.emp_first_name} ${employee.emp_last_name}` : `Employee #${empId}`;
    };

    useEffect(() => {
        // Group relationships by type
        const grouped = relationships.reduce((acc, rel) => {
            const type = rel.relationtype || 'Other';
            if (!acc[type]) {
                acc[type] = [];
            }
            acc[type].push(rel);
            return acc;
        }, {});
        setGroupedRelationships(grouped);
    }, [relationships]);

    const relationshipTypes = Object.keys(groupedRelationships);

    return (
        <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
                <Grid size={props.leftColumnSize || 4}>
                    <Stack spacing={1}>
                        <Typography variant="h5">Employee Relationships</Typography>
                        <Typography variant="body1" sx={{ color: 'gray' }}>
                            View your relationships with other employees in the organization
                        </Typography>
                    </Stack>
                </Grid>
                <Grid size={props.rightColumnSize || 8}>
                    {loading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 150 }}>
                            <CircularProgress size={40} />
                        </Box>
                    ) : relationshipTypes.length === 0 ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 100 }}>
                            <Typography variant="body1" color="text.secondary">
                                No relationships configured
                            </Typography>
                        </Box>
                    ) : (
                        <Grid container spacing={2}>
                            {relationshipTypes.map((type) => (
                                <Grid size={6} key={type}>
                                    <Paper sx={{ p: 2 }} variant="outlined">
                                        <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                                            {type} for
                                        </Typography>
                                        <Divider sx={{ mb: 1 }} />
                                        <List dense disablePadding>
                                            {groupedRelationships[type].map((rel, index) => (
                                                <ListItem key={index} disableGutters sx={{ py: 0.5 }}>
                                                    <ListItemText 
                                                        primary={getEmployeeName(rel.relatedto)}
                                                        primaryTypographyProps={{ variant: 'body2' }}
                                                    />
                                                </ListItem>
                                            ))}
                                        </List>
                                    </Paper>
                                </Grid>
                            ))}
                        </Grid>
                    )}
                </Grid>
            </Grid>
        </Box>
    );
};

export default ViewEmployeeRelationship;
